/**
 * App routes
 */
export const HOME_ROUTE = ''

/**
 * Random variables used in the app
 */
export const LOGO_PERCENTAGE_HEIGHT: number = 0.1
// Make sure to modify $menu-width in vertical-menu.scss too
export const HOR_MENU_WIDTH: number = 0